export enum LoginResult {
  Success,
  Failure,
  Locked
}
